<template lang="pug">
  v-container.fill-height(fluid='')
    v-row(
      align="center"
      justify="center"
    )
      v-col(
        cols='12'
        sm='8'
        md='6'
        lg='4'
        :class="{ 'px-0' : $vuetify.breakpoint.smAndDown }"
      )
        v-card.elevation-12
          v-toolbar(
            color='primary'
            dark
            flat
          )
            v-toolbar-title Set New Password
          v-card-text
            template(v-if="linkError")
              v-alert(
                type="error"
                text
              ) {{ linkError }}
              .text-center
                router-link(:to="{ name: 'reset-password-request' }") Request a new reset link
            v-form.pa-4(
              v-else
              ref="form"
              v-model="valid"
              @submit.prevent="submit"
            )
              v-text-field(
                filled
                label="New Password"
                type="password"
                autocomplete="new-password"
                v-model="password"
                :rules="[rules.required, rules.isEightCharacters]"
                hint="Must include at least 8 characters"
              )
              v-text-field(
                filled
                label="Confirm Password"
                type="password"
                autocomplete="new-password"
                v-model="confirmPassword"
                :rules="[rules.required, passwordsMatch]"
              )
              v-btn.mt-2(
                block
                color="primary"
                type="submit"
                :disabled="!valid"
                :loading="sending"
                depressed
              ) Reset Password
</template>

<script>
import validations from '@/mixins/validationRulesMixin'
import { resetPassword } from '@/services/authManagement'

const INVALID_LINK_MESSAGE = 'This reset link is invalid or has expired.'

export default {
  name: 'ResetPassword',
  mixins: [validations],
  data () {
    return {
      password: '',
      confirmPassword: '',
      sending: false,
      linkError: this.$route.query.token ? null : INVALID_LINK_MESSAGE
    }
  },
  methods: {
    passwordsMatch (value) {
      return value === this.password || 'Passwords must match'
    },
    async submit () {
      this.sending = true

      try {
        await resetPassword(this.$route.query.token, this.password)
        this.$snackSuccess('Your password has been reset. You can now log in.')
        this.$router.push({ name: 'login' })
      } catch (error) {
        if (error.code === 400) {
          this.linkError = INVALID_LINK_MESSAGE
        } else {
          this.$snackError(error.message)
        }
      } finally {
        this.sending = false
      }
    }
  }
}
</script>
